export const validateEmail: (email: string) => boolean = (email) => {
  if (!email.trim()) return false; // check for blank email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhoneNumber: (phone: string) => boolean = (phone) => {
  if (!phone.trim()) return false; // check for blank phone number
  const phoneNumberRegex = /^\+\d{11}$/;
  return phoneNumberRegex.test(phone);
};

export const validateDate = (date: string): boolean => {
  if (!date.trim()) return false; // check for blank date
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return dateRegex.test(date);
};

export const validateTariffCode = (code: string): boolean => {
  if (!code.trim()) return false; // check for blank code
  const codeRegex = /^\d{5}$/;
  return codeRegex.test(code);
};
